module.exports = __webpack_public_path__ + "img/Documentation.9a35fecc.svg";